"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = exports.login = exports.getUserNotes = exports.editNote = exports.deleteNote = exports.createUserNote = void 0;
var baseHeaders = function () {
    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    return myHeaders;
};
var defaultHeaders = function () {
    var headers = baseHeaders();
    var token = sessionStorage.getItem("JWT");
    headers.append("Authorization", "bearer " + token);
    return headers;
};
var configureRequest = function (method, headers, data // TODO: should probably be a generic
) {
    var config = {
        method: method,
        headers: headers,
        cache: "default",
    };
    if (data) {
        config.body = JSON.stringify(data);
    }
    return config;
};
// TODO: create a base URL
var createUserNote = function (userId, note) {
    var request = new Request(process.env.API_URL + "/api/users/" + userId + "/notes");
    var init = configureRequest("POST", defaultHeaders(), note);
    return fetch(request, init);
};
exports.createUserNote = createUserNote;
var deleteNote = function (noteId) {
    var request = new Request(process.env.API_URL + "/api/notes/" + noteId);
    var init = configureRequest("DELETE", defaultHeaders());
    return fetch(request, init);
};
exports.deleteNote = deleteNote;
var editNote = function (noteId, note) {
    var request = new Request(process.env.API_URL + "/api/notes/" + noteId);
    var init = configureRequest("PUT", defaultHeaders(), note);
    return fetch(request, init);
};
exports.editNote = editNote;
var getUserNotes = function (userId) {
    var request = new Request(process.env.API_URL + "/api/users/" + userId + "/notes");
    var init = configureRequest("GET", defaultHeaders());
    return fetch(request, init);
};
exports.getUserNotes = getUserNotes;
var login = function (_a) {
    var username = _a.username, password = _a.password;
    var request = new Request(process.env.API_URL + "/api/login?username=" + username + "&password=" + password);
    var init = configureRequest("POST", baseHeaders());
    return fetch(request, init);
};
exports.login = login;
var register = function (credentials) {
    var request = new Request(process.env.API_URL + "/api/users/new");
    var init = configureRequest("POST", baseHeaders(), credentials);
    return fetch(request, init);
};
exports.register = register;
